import { CoupanCityConstant } from "./CoupanCityConstant";

const CoupanCityActions = {};

CoupanCityActions.getCoupanCityActions = () => {
  return {
    type: CoupanCityConstant.COUPAN_CITY_SAGA,
  };
};

CoupanCityActions.postAddCoupanModel = (payload) => {
  return {
    type: CoupanCityConstant.POST_ADD_COUPAN_MODEL_SAGA,
    payload: payload,
  };
};

//DELETE
CoupanCityActions.getCoupanCityDeleteActions = (id) => {
  return {
    type: CoupanCityConstant.COUPAN_CITY_DELETE_SAGA,
    payload: id,
  };
};

CoupanCityActions.getChargingNetworkDeleteActions = (id) => {
  return {
    type: CoupanCityConstant.CHARGING_NETWORK_DELETE_SAGA,
    payload: id,
  };
};
CoupanCityActions.getSlectCouponCity = () => {
  return {
    type: CoupanCityConstant.GET_SELECT_COUPON_CITY_SAGA,
  };
};

CoupanCityActions.getSelectChargingNetwork = () => {
  return {
    type: CoupanCityConstant.GET_SELECT_CHARGING_NETWORK_SAGA,
  };
};

export { CoupanCityActions };
